<template>
	<div class="curtain-background">
		<h1>{{ displayProgress }}%</h1>
	</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	name: 'LoadingScreen',
	computed: {
		...mapState({
			progress: (state) => state.global.assets.progress,
			loaded: (state) => state.global.assets.loaded,
		}),
		displayProgress() {
			return (this.progress * 100).toFixed(0);
		},
	},
	watch: {
		loaded(isLoaded, wasLoaded) {
			if (isLoaded && !wasLoaded) {
				this.complete();
			}
		},
	},
	methods: {
		complete() {
			this.$router.push("/");
		},
	},
};
</script>

<style lang="scss" scoped>
	.curtain-background {
		height: 100%;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		background-image: url('~@/assets/images/curtain-background.png');
		background-position: right top;
		background-repeat: repeat-x;
		background-size: auto 100%;
		color: $off-white;

		@include desktop { color: $background-color; }
	}
</style>



// WEBPACK FOOTER //
// src/components/views/Loading.vue